import { createContext } from "react";

export const EditorSocketContext = createContext(null);